/**
 * Credit Account Type Definitions.
 */

export interface CreditAccount {
  id: string;
  organization_id: string;
  name: string;
  account_type: string;
  credit_limit: number | null;
  current_balance: number;
  interest_rate: number;
  compounding_method: string;
  provider: string | null;
  account_number_last4: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreditAccountCreate {
  name: string;
  account_type: string;
  credit_limit?: number;
  current_balance?: number;
  interest_rate?: number;
  compounding_method?: string;
  provider?: string;
  account_number_last4?: string;
}

export interface CreditTransaction {
  id: string;
  credit_account_id: string;
  transaction_type: string;
  amount: number;
  description: string | null;
  reference_id: string | null;
  reference_type: string | null;
  transaction_date: string;
  created_at: string;
}

export const ACCOUNT_TYPES = [
  { value: "line_of_credit", label: "Line of Credit" },
  { value: "credit_card", label: "Credit Card" },
  { value: "loan", label: "Loan" },
  { value: "other", label: "Other" },
] as const;
